import { TYPES } from "./types";
import { aiConversationService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getAIConversations = () => async (dispatch) => {
  try {
    const result = await aiConversationService.getAIConversations();
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_ALL_AI_CONVERSATIONS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_ALL_AI_CONVERSATIONS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
}

export const updateAiConversation = (conversationData) => async (dispatch) => {
  try {
    const result = await aiConversationService.updateAiConversation(conversationData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_AI_CONVERSATION_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_AI_CONVERSATION_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
}

export const aiConversationAction = {
  getAIConversations,
  updateAiConversation
}
